"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getIsMobileTab() {
    return (state, actions, { tabName = state.ui.currentTabName } = {}) => () => tabName === 'mobile';
}
exports.getIsMobileTab = getIsMobileTab;
//# sourceMappingURL=get-is-mobile-tab.js.map